export default {"src":"/_next/static/media/check.43483f53.svg","height":14,"width":18,"blurWidth":0,"blurHeight":0};